import React from "react";
import { CheckIcon } from "lucide-react";
import type { BookingStep } from "../../hooks/useBookingFlow";
const steps: Array<{
  id: BookingStep;
  label: string;
}> = [{
  id: "service",
  label: "Soin"
}, {
  id: "slot",
  label: "Créneau"
}, {
  id: "details",
  label: "Confirmation"
}];
interface BookingStepperProps {
  current: BookingStep;
  canGoTo: (step: BookingStep) => boolean;
  onStepClick: (step: BookingStep) => void;
}
export function BookingStepper({
  current,
  canGoTo,
  onStepClick
}: BookingStepperProps) {
  const currentIndex = steps.findIndex(s => s.id === current);
  return <nav aria-label="Étapes de réservation" data-id="element-66" data-mp="qxa3ubs1djit">
      <ol className="flex items-center gap-2 sm:gap-4" data-id="element-67" data-mp="qvyt1s06bbi7">
        {steps.map((step, index) => {
        const isCurrent = index === currentIndex;
        const isDone = index < currentIndex;
        const clickable = !isCurrent && canGoTo(step.id);
        return <li key={step.id} className="flex items-center gap-2 sm:gap-4" data-id="element-68" data-mp="36o65yyla1ice" data-mpi={index}>
              <button type="button" onClick={() => onStepClick(step.id)} disabled={!clickable} aria-current={isCurrent ? "step" : undefined} className="flex items-center gap-2 rounded-full text-sm disabled:cursor-default" data-id="element-69" data-mp="3rdiz6dppvtda">
                <span className={`flex h-7 w-7 items-center justify-center rounded-full text-xs font-semibold transition-colors duration-150 ${isCurrent ? "bg-brand text-white" : isDone ? "bg-brand-soft text-brand" : "border border-line bg-white text-muted"}`} data-id="element-70" data-mp="3mdehikd2oslh">
                  {isDone ? <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-71" data-mp="33lveidj1tejg" /> : index + 1}
                </span>
                <span className={`whitespace-nowrap ${isCurrent ? "font-medium text-ink" : "text-muted"}`} data-id="element-72" data-mp="2tq0rl67skxav">
                  {step.label}
                </span>
              </button>
              {index < steps.length - 1 && <span className="h-px w-6 bg-line sm:w-12" aria-hidden="true" data-id="element-73" data-mp="vguwfsgi4a1d" />}
            </li>;
      })}
      </ol>
    </nav>;
}